import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import heic2any from 'heic2any';
export default {
  name: 'FibPhotoUpload',
  props: {
    file: {
      type: String,
      default: ''
    },
    maxFileSize: {
      type: Number,
      default: null
    },
    noBackground: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    deleteImage: {
      type: Boolean,
      default: false
    },
    useBaseTheme: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    isStaff: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      edit: true,
      addImage: false,
      takePhoto: false,
      uploadFile: false,
      url: null
    };
  },
  computed: {
    theme: function theme() {
      if (this.useBaseTheme) {
        return this.$store.getters['theme/baseTheme'];
      }

      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.theme.primaryColor
      };
    },
    buttonColor: function buttonColor() {
      return this.theme.secondaryColor;
    },
    isApp: get('config/isApp')
  },
  watch: {
    open: function open(val) {
      this.addImage = val;
    }
  },
  mounted: function mounted() {
    if (this.file) {
      return this.edit = false;
    }
  },
  methods: {
    chooseFile: function chooseFile() {
      this.$refs.file.click();
    },
    initCamera: function initCamera() {
      this.$refs.photo.click();
    },
    handleFileChange: function handleFileChange(event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var file, blobURL, blobRes, blob, conversionResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = event.target.files[0]; // Ignore dodgy files

                if (file) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (!(_this.maxFileSize && file.size >= _this.maxFileSize)) {
                  _context.next = 7;
                  break;
                }

                _this.addImage = false;

                _this.$store.dispatch('errors/display', _this.$tc('checkout.uploadFileSizeError', _this.$options.filters.prettyBytes(_this.maxFileSize)));

                return _context.abrupt("return");

              case 7:
                if (!(file.type === 'image/heic' || file.type === 'image/heif')) {
                  _context.next = 21;
                  break;
                }

                blobURL = URL.createObjectURL(file); // convert "fetch" the new blob url

                _context.next = 11;
                return fetch(blobURL);

              case 11:
                blobRes = _context.sent;
                _context.next = 14;
                return blobRes.blob();

              case 14:
                blob = _context.sent;
                _context.next = 17;
                return heic2any({
                  blob: blob
                });

              case 17:
                conversionResult = _context.sent;
                // convert to blob url
                _this.url = URL.createObjectURL(conversionResult);
                _context.next = 22;
                break;

              case 21:
                _this.url = URL.createObjectURL(file);

              case 22:
                _this.$emit('input', file);

                _this.edit = true;
                _this.addImage = false;
                _this.edit = false;

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    removeImage: function removeImage() {
      this.url = null;
      this.addImage = false;
      this.edit = true;
      this.$emit('remove-image', true);
    },
    close: function close() {
      this.addImage = false;
      this.takePhoto = false;
      this.uploadFile = false;
      this.$emit('close', true);
    }
  }
};